import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=27ec443c&scoped=true"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=27ec443c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec443c",
  null
  
)

export default component.exports